module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block bg-grey-800"
  }, [_c('h3', {
    staticClass: "card-title"
  }), _vm._v(" "), (_vm.isLoading && !_vm.team) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 card-stat"
  }, [_c('loading-indicator')], 1)]) : _c('div', [_c('discount-package', {
    attrs: {
      "team": _vm.team
    }
  }), _vm._v(" "), _c('pricing-plan', {
    attrs: {
      "team": _vm.team
    },
    on: {
      "loadChanged": _vm.pricingPlanLoadChanged
    }
  }), _vm._v(" "), _c('pay-plan', {
    attrs: {
      "team": _vm.team
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-548ecd4b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/packages/CurrentPackage.vue
// module id = 533
// module chunks = 1